// app/javascript/controllers/ruby_ui--dialog_controller.js
import { Controller } from "@hotwired/stimulus"

// data-controller="ruby-ui--dialog"
export default class extends Controller {
  static targets = ["content"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    if (this.openValue) this.open()
  }

  open(event) {
    if (event) event.preventDefault();

    document.body.insertAdjacentHTML('afterbegin', this.contentTarget.innerHTML);
    document.documentElement.classList.add("!tw-overflow-hidden", "tw-bg-black/50", "tw-backdrop-blur-sm");

    const dialog = document.querySelector('[data-controller="ruby-ui--dialog"]');
    if (dialog) {
      dialog.classList.add(
          "tw-fixed",
          "tw-inset-0",
          "tw-flex",
          "tw-items-center",
          "tw-justify-center",
          "tw-p-4",
          "tw-z-50"
      );
    }
  }

  dismiss() {
    document.documentElement.classList.remove("!tw-overflow-hidden", "tw-bg-black/50", "tw-backdrop-blur-sm");
    this.element.remove()
  }
}